import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { WindowsService } from 'src/app/_services/windows.services';
import { ArgumentEntered } from '../argument/argument.model';

@Component({
  selector: 'app-subquery',
  templateUrl: './subquery.component.html',
  styleUrls: ['./subquery.component.scss']
})
export class SubqueryComponent implements OnInit {

  listArguments: ArgumentEntered [] = [] ;
  queryid: string = '';
  queryColumnvalue: string = '';
  currenteNameQuery='';

  constructor(
    private windowsService: WindowsService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {

    this.queryid = this.activatedRoute.snapshot.params['queryid'];
    this.queryColumnvalue = this.activatedRoute.snapshot.params['value'];
    this.queryColumnvalue = this.queryColumnvalue.replace("3!B", "/");
    const winRef = this.windowsService.nativeWindow;
    this.listArguments = JSON.parse(winRef.name).data; // se recuperan los argumentos del padre a travez del la propiedad name.data de la windows

    this.currenteNameQuery=`${this.queryid} - ${this.queryColumnvalue}`;

    document.title = this.currenteNameQuery;

  }

}
